import React from 'react';
import './CallToAction.css';
import { toSentenceCase } from '../utils/textUtils';

function CallToAction() {
  const handleNavigation = (page) => {
    if (window.navigateTo) {
      if (page === 'inscription') {
        window.navigateTo('student-registration');
      } else {
        window.navigateTo(page);
      }
      window.scrollTo(0, 0);
    }
  };

  return (
    <section className="call-to-action section">
      <div className="container">
        {/* Slogan principal */}
        <div className="slogan-section">
          <div className="slogan-content">
            <h2 className="slogan-title">
              {toSentenceCase("Au delà des Diplômes, professionnalisez-vous au lycée")}
              <span className="highlight"> « LES PALMIERS »</span>
            </h2>
            <p className="slogan-subtitle">
              {toSentenceCase("1er Formateur de la formation par alternances au Bénin")}
            </p>

            <div className="achievements-box">
              <div className="achievement-item">
                <div className="achievement-badge">2ème</div>
                <p>Olympiade Nationale de la filière MMV</p>
              </div>
              <div className="achievement-item">
                <div className="achievement-badge">2ND</div>
                <p>Vice champion au CAMP d'excellence des chefs d'Etablissement</p>
              </div>
            </div>

            <div className="motto-section">
              <h3 className="motto">
                {toSentenceCase("FAITES LE CHOIX DU CONCRET AU BÉNIN")}
                <br />
                <span className="motto-highlight">{toSentenceCase("VOTRE ARGENT MÉRITE NOTRE EXPERTISE !")}</span>
              </h3>
            </div>
          </div>
        </div>

        {/* Appel à l'action principal */}
        <div className="main-cta">
          <div className="cta-content">
            <h2 className="cta-title">
              {toSentenceCase("Inscriptions ouvertes 2026–2027")}
            </h2>
            <p className="cta-subtitle">
              {toSentenceCase("Réservez votre place dès aujourd'hui !")}
            </p>
            <button 
              className="btn-cta"
              onClick={() => handleNavigation('inscription')}
            >
              <span>{toSentenceCase("S'inscrire maintenant")}</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Cycles disponibles */}
        <div className="cycles-section">
          <div className="cycles-header">
            <h3 className="cycles-title">
              {toSentenceCase("ENSEIGNEMENT SECONDAIRE GÉNÉRAL « LES PALMIERS »")}
            </h3>
            <p className="cycles-subtitle">{toSentenceCase("CYCLES DISPONIBLES")}</p>
          </div>
          
          <div className="cycles-grid">
            <div className="cycle-card">
              <div className="cycle-number">1er</div>
              <h4>{toSentenceCase("CYCLE DE L'ENSEIGNEMENT GÉNÉRAL")}</h4>
              <div className="cycle-details">
                <p><strong>Classes :</strong> 6ème, 5ème, 4ème et 3ème</p>
                <p><strong>Diplôme :</strong> BEPC</p>
              </div>
              <div className="cycle-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
            </div>
            
            <div className="cycle-card">
              <div className="cycle-number">2nd</div>
              <h4>{toSentenceCase("CYCLE DE L'ENSEIGNEMENT TECHNIQUE ET PROFESSIONNEL")}</h4>
              <div className="cycle-details">
                <p><strong>Classes :</strong> 2nde, 1ère et Tle SÉRIE C/D</p>
                <p><strong>Diplôme :</strong> BAC C/D</p>
              </div>
              <div className="cycle-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M6 12v5c3 3 9 3 12 0v-5" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;